const channelDictEN = {
  channelHeaderNote: "Selected shops for ScontiPoste",
  channelCart: "Cart",
  channelTicketTitle: "{percent}% ScontiPoste cashback",
  channelTicketRule:
    "Pay with your Postepay or BancoPosta card: Poste Italiane credits the cashback, usually within 5 days.",
  channelTicketWarning:
    "Other cards work for the purchase, but Poste Italiane does not recognize the cashback.",
  channelSearchPlaceholder: "Search for a product",
  channelSearch: "Search",
  channelAllCategories: "All",
  channelNoProducts: "No products here yet. Try another category or another search.",
  channelLoadMore: "Show more products",
  channelFreeDelivery: "Free delivery",
  channelPickup: "In-store pickup",
  channelSoldBy: "Sold by {seller}",
  channelAddToCart: "Add to cart",
  channelAdded: "Added to cart",
  channelGoToCart: "Go to cart",
  channelQuantity: "Quantity",
  channelChooseOption: "Choose {name}",
  channelChooseVariation: "Choose an option",
  channelOutOfStock: "Out of stock",
  channelPickupAt: "Pickup at: {address}",
  channelPickupDays: "You have {days} days to pick it up.",
  channelBackToShop: "Back to products",
  channelDescription: "Description",
  channelCartTitle: "Your cart",
  channelCartEmpty: "Your cart is empty.",
  channelCartEmptyAction: "Browse products",
  channelShippedBy: "Shipped by {seller}",
  channelPickupFrom: "Pickup at {seller}",
  channelRemove: "Remove",
  channelDecrease: "Decrease quantity",
  channelIncrease: "Increase quantity",
  channelShipping: "Delivery",
  channelShippingFree: "Free",
  channelTotal: "Total",
  channelPricesIncludeFees: "Prices include service fees.",
  channelCheckoutCta: "Continue to checkout",
  channelUnavailableItem: "This product is no longer available: remove it to continue.",
  channelCheckoutTitle: "Complete your purchase",
  channelYourDetails: "Your details",
  channelFirstname: "First name",
  channelSurname: "Last name",
  channelEmail: "Email",
  channelEmailHelp: "We send your order confirmation here.",
  channelPhone: "Phone (optional)",
  channelDeliveryAddress: "Delivery address",
  channelAddress: "Street",
  channelNumber: "House number",
  channelPostalCode: "Postal code",
  channelCity: "City",
  channelProvince: "Province (code, e.g. RM)",
  channelItalyOnly: "We deliver in Italy only.",
  channelPickupOnly: "All products are picked up in store: no address needed.",
  channelPayment: "Payment",
  channelCardHelp: "Use your Postepay or BancoPosta card to get the cashback.",
  channelCardName: "Name on card",
  channelCardNumber: "Card number",
  channelCardExpiry: "Expiry date",
  channelCardCvv: "CVV",
  channelPay: "Pay {total}",
  channelFillRequired: "Fill in the required fields.",
  channelInvalidEmail: "Enter a valid email.",
  channelInvalidCard: "Check your card details.",
  channelPaymentFailed: "The payment did not go through. Try again or use another card.",
  channelAccountNote: "With this purchase we create a free Extraconomy account for you to track your orders.",
  channelOrderSummary: "Summary",
  channelThanksTitle: "Order confirmed",
  channelThanksIntro: "Thank you! We received your payment of {total}.",
  channelThanksOrders: "Your orders",
  channelOrderNumber: "Order no. {id}",
  channelThanksDelivery: "The seller ships the parcel to the address you entered.",
  channelThanksPickup: "You pick up the product at the seller's store.",
  channelThanksNewAccount:
    "We created your Extraconomy account with {email}. Open the email we sent you and choose a password to track your orders.",
  channelThanksExistingAccount: "The order is in your Extraconomy account ({email}). Log in to track it.",
  channelLogin: "Log in",
  channelThanksCashback:
    "If you paid with Postepay or BancoPosta, Poste Italiane credits {percent}% cashback, usually within 5 days.",
  channelContinueShopping: "Keep shopping",
  channelThanksMissing: "The order details are no longer available on this page. You can find them in the confirmation email.",
  channelPasswordTitle: "Create your password",
  channelPasswordIntro: "With a password you can log in and track your orders.",
  channelPassword: "Password",
  channelPasswordConfirm: "Repeat the password",
  channelPasswordHelp: "At least 8 characters.",
  channelPasswordMismatch: "The passwords do not match.",
  channelPasswordSave: "Create password and log in",
  channelPasswordInvalidLink:
    "This link is invalid or has expired. To get a new one, use \"Forgot password\" on the login page.",
  channelGoToLogin: "Go to login",
  channelProcessingTitle: "We are confirming your payment",
  channelProcessingText: "This can take a few seconds. Do not close or reload this page.",
  channelInvalidItalianAddress: "Enter a 5-digit Italian postal code and the province code (e.g. RM).",
  channelError500438: "Enter a 5-digit Italian postal code and the province code (e.g. RM).",
  orderDetailsChannelCashbackBuyer: "ScontiPoste order: the cashback is not credited on Extraconomy. If you paid with a Postepay or BancoPosta card, Poste Italiane credits it to your card, usually within 5 days.",
  orderDetailsChannelCashbackSeller: "ScontiPoste order: this cashback is deducted from the sale and paid to the customer by Poste Italiane, on their card.",
  channelLoading: "Loading",
  channelGenericError: "Something went wrong. Try again in a moment.",
  channelError500037: "Product not found.",
  channelError500069: "Choose a product option.",
  channelError500074: "One of the products is out of stock. Check your cart.",
  channelError500417: "This shop does not exist.",
  channelError500418: "This shop is not available right now.",
  channelError500419: "One of the products is no longer available. Check your cart.",
  channelError500420: "Check the quantities in your cart.",
  channelError500423: "The cart prices have changed. Check the total and try again.",
  channelError500424: "The payment session is not valid. Reload the page and try again.",
  channelError500425: "We could not confirm the payment. If you were charged, the amount is refunded.",
  channelError500426: "Enter the delivery address.",
  channelError500427: "We deliver in Italy only.",
  channelError500428: "Enter your first name, last name and a valid email.",
  channelError500429: "You can not buy your own products.",
  channelError500430: "We could not complete the purchase and the payment was refunded.",
  channelError500431: "This link is invalid or has expired. To get a new one, use \"Forgot password\" on the login page.",
  channelError500432: "The password must have at least 8 characters.",
  channelError500433: "The cart has too many products.",
};

export default channelDictEN;
